// extracted by mini-css-extract-plugin
export default {"tableWrapperContainer":"Table_tableWrapperContainer__0bpfg","pagination":"Table_pagination__PwuWa"};